export default __webpack_public_path__ + "static/media/bird.cdebc710.jpg";